export default "__VITE_ASSET__BIqG8U$N__"